<template>
  <div id="app">
    <Prod
      @increase="totalCount++"
      @diminish="totalCount--"
    />
    <div class="cart fixed fixed-top fixed-right">
      <div class="cart__head">
        <p class="cart__desc">商品數量</p>
      </div>
      <div class="cart__body">
        <p class="cart__price">{{ totalCount }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Prod from '@/components/Prod/ProdContainer';

export default {
  name: 'App',
  components: {
    Prod,
  },
  data(){
    return {
      totalCount: 0,
    };
  },
}
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.container {
  width: 1200px;
}

.fix-margin {
  border-top: solid 1px transparent;
  border-bottom: solid 1px transparent;
}

.img-resp {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
}

.row {
  margin-left: -15px;
  margin-right: -15px;
}

.fixed {
  position: fixed;
}

.fixed-right {
  right: 0;
}

.fixed-top {
  top: 0;
}

body {
  font-size: 15px;
  font-family: Arial, Helvetica, "LiHei Pro", "Microsoft JhengHei", MingLiU, sans-serif;
}

.cart {
  text-align: center;
}

.cart__head {
  background-color: #ff66b0;
}

.cart__desc, .cart__price {
  margin: 0;
  padding: 7px 10px;
  color: #fff;
}

.cart__price {
  font-size: 2em;
  background-color: #ff007c;
}

</style>



// WEBPACK FOOTER //
// src/App.vue